import React from 'react';
import {Checkbox, Dropdown, Icon, Input, Popup, Table} from 'semantic-ui-react';
import {getDropdownOptions} from '../../../common/util/dropdown';

const noMargin = {'paddingTop': '0', 'paddingBottom': '0'};

const renderTransportistPopup = (item, disabled) => {
  return (
    <Popup pinned on='click' inverted={item.value.length === 0} disabled={disabled}
      trigger={<Icon link name='local-shipping' size='big' color='red' />}
      content={
        item.value.length > 0 ?
          <div style={{'padding': '0.5em 0'}}>
            <Table stackable compacts striped>
              <Table.Header fullWidth>
                <Table.HeaderCell textAlign='center' style={noMargin}>Compañía</Table.HeaderCell>
                <Table.HeaderCell textAlign='center' style={noMargin}>Transportista</Table.HeaderCell>
              </Table.Header>
              <Table.Body>
                {item.value.map((x, i) => {
                  return (
                    <Table.Row key={`transportist-key-${i}`}>
                      <Table.Cell collapsing>{x.courierName}</Table.Cell>
                      <Table.Cell collapsing>{x.driverName}</Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </div> : <div>No hay transportistas asociados</div>
      }
    />
  );
};
const AgenciesTableInputView = ({item, editable, edit, provincesList, dealersList, handleAgencyStatus}) => {
  if (item.cell.column.id === 'driverArray') {
    return renderTransportistPopup(item, false);
  }

  if (item.cell.column.id === 'status') {
    return !editable ?
      <Checkbox toggle checked={item.value === 'A' ? true : false} className='green'
        onChange={(e, input) => handleAgencyStatus(e, input.checked, item.row.original)} /> : '';
  }

  if (item.cell.column.id === 'code') {
    return <div>{item.value}</div>;
  }

  if (item.cell.column.id === 'identification') {
    return <div>
      {dealersList.length > 0 ? dealersList.find((x) => x.identification === item.value) ?
        dealersList.find((x) => x.identification === item.value).name : '' : ''}
    </div>;
  }

  if (item.cell.column.id === 'ruc') {
    return <div>{item.value}</div>;
  }

  if (item.cell.column.id === 'provinceCode') {
    return editable ?
      <Dropdown fluid search selection id='provinceCode'
        value={edit.getAgencyEditingValue(item.cell.column.id)}
        options={getDropdownOptions(provincesList, 'code', 'name')}
        onChange={(e, input) => edit.handleAgencyValue(e, input)} /> :
      <div>{provincesList ? provincesList.find((x) => x.code === item.value).name : ''}</div>;
  }

  if (item.cell.column.id === 'cantonCode') {
    return editable ?
      <Dropdown fluid search selection id='cantonCode'
        value={edit.getAgencyEditingValue(item.cell.column.id)}
        options={getDropdownOptions(
          provincesList.find((x) =>
            x.code === item.row.original.provinceCode).array_canton,
          'cantonCode', 'cantonName')}
        onChange={(e, input) => edit.handleAgencyValue(e, input)} /> :
      <div>{provincesList ? provincesList.find((x) =>
        x.code === item.row.original.provinceCode).array_canton
        .find((x) => x.cantonCode === item.value).cantonName : ''}</div>;
  }

  return editable ?
    <Input fluid className='' value={edit.getAgencyEditingValue(item.cell.column.id)}
      ref={edit.setAgencyRef}
      id={item.cell.column.id}
      onChange={(e, input) => edit.handleAgencyValue(e, input)} /> :
    <div>{item.value}</div>;
};
 
export default AgenciesTableInputView;
